import { Link } from "react-router-dom";
import { Target, TrendingUp, LineChart, Infinity as InfinityIcon, ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/Primitives";
import { SERVICES } from "@/lib/content";

const ICONS = { Target, TrendingUp, LineChart, Infinity: InfinityIcon };

export const ServicePillars = () => {
  const pillars = SERVICES.filter((s) => !s.premium);
  const partnership = SERVICES.find((s) => s.premium);

  return (
    <section className="section-py" data-testid="services-section">
      <div className="container-bp">
        <SectionHeading
          align="center"
          eyebrowTone="gold"
          eyebrow="The Beyond Difference"
          title="Bankers hiring bankers. From recruitment through development — one partner, full lifecycle."
        />

        <RevealGroup className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {pillars.map((s) => {
            const Icon = ICONS[s.icon] || Target;
            return (
              <RevealItem key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group flex h-full flex-col rounded-[var(--radius-lg)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[color:var(--bp-teal)]/60 hover:shadow-[var(--shadow-lift)]"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[color:var(--bp-teal)]/40 bg-[color:var(--bp-teal-soft)] text-[color:var(--bp-teal)]">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-6 font-display text-xl font-semibold text-[color:var(--bp-cream)]">{s.name}</h3>
                  <p className="mt-3 flex-1 text-[14px] leading-relaxed text-[color:var(--bp-text-muted)]">{s.summary}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-[13px] font-semibold text-[color:var(--bp-teal)]">
                    Explore {s.short}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </RevealItem>
            );
          })}
        </RevealGroup>

        {partnership && (
          <Reveal delay={0.1}>
            <Link
              to="/services/beyond-partnership"
              data-testid="beyond-partnership-banner"
              className="group mt-6 flex flex-col items-start justify-between gap-6 overflow-hidden rounded-[var(--radius-lg)] border border-[color:var(--bp-gold)]/45 bg-[color:var(--bp-surface)] p-8 transition-all duration-300 hover:border-[color:var(--bp-gold)]/80 md:flex-row md:items-center grain-card"
            >
              <div className="flex items-start gap-5">
                <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[color:var(--bp-gold)]/50 text-[color:var(--bp-gold)]">
                  <InfinityIcon className="h-5 w-5" />
                </span>
                <div>
                  <p className="eyebrow text-[color:var(--bp-gold)]">The integrated retainer</p>
                  <h3 className="mt-2 font-display text-2xl font-semibold text-[color:var(--bp-cream)]">The Beyond Partnership</h3>
                  <p className="mt-2 max-w-xl text-[14px] text-[color:var(--bp-text-muted)]">{partnership.summary}</p>
                </div>
              </div>
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-[color:var(--bp-gold)]/50 px-5 py-3 text-[13px] font-semibold text-[color:var(--bp-gold)] transition-colors group-hover:bg-[color:var(--bp-gold)] group-hover:text-[color:var(--bp-bg)]">
                Discover the retainer <ArrowUpRight className="h-4 w-4" />
              </span>
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
};
